<template>
  <div class="Product">
    <div class="Product_wrap" ref="ProductPage">
      <div class="Product_content">
        <div class="Product_content_title ">
          <p>{{$t("Products.ProductsTop")}} </p>
          <!-- 全面渗透自动驾驶领域 -->
        </div>
      </div>
    </div>
    <!-- 商用车主动安全设备 -->
    <div class="Product_wrap" style="background:rgba(251,251,251,1);">
      <div class="Product_KY-LFD">
        <div class="Product_KY-LFD_title">
          <headerbar v-bind:message="$t(parentMeg)"></headerbar>
        </div>
        <div class="Product_KY-LFD_content">
          <div class="Product_KY-LFD_content_img">
            <img v-lazy="equipment2" alt="">
          </div>
          <div class="Product_KY-LFD_content_text">
            <h3>{{$t("Products.commercial.ActiveKYLFD")}}</h3>
            <p>{{$t("Products.commercial.ActiveKYLFDtext")}}</p>
          </div>
          <div class="Product_KY-LFD_pointTo">
            <span></span>
            <span></span>
            <h5>{{$t("Products.commercial.ActiveKYLFDbottom")}}</h5>
          </div>
        </div>
        <div class="Product_vice_content">
          <div class="Product_vice_content_text">
            <h3>{{$t("Products.commercial.function")}}</h3>
            <p>{{$t("Products.commercial.commercialAdas")}}</p>
            <p>{{$t("Products.commercial.commercialtired")}}</p>
          </div>
          <div class="Product_vice_content_img">
            <img v-lazy="equipment3" alt="">
          </div>
          <div class="Product_vice_pointTo">
            <h5>{{$t("Products.commercial.camera")}}</h5>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>
    <!-- 前装方案 -->
    <div class="Product_wrap" style="background:#fff;" ref="ProductPage2">
      <div class="Product_KY101">
        <div class="Product_KY101_title">
          <headerbar v-bind:message="$t(parentMega)"></headerbar>
        </div>
        <div class="Product_KY101_content">
          <div class="Product_KY101_content_img">
            <img v-lazy="equipment1" alt="">
          </div>
          <div class="Product_KY101_content_text">
            <h3>{{$t("Products.front.frontadas")}}</h3>
            <p>
              <b>{{$t("Products.front.Features")}}</b>{{$t("Products.front.Featurestext")}}</p>
          </div>
          <div class="Product_KY101_pointTo">
            <span></span>
            <span></span>
            <h5>{{$t("Products.front.Featuresbottom")}}</h5>
          </div>
        </div>
      </div>
    </div>
    <!-- SDK -->
    <div class="Product_wrap" style="background:rgba(251,251,251,1);" ref="ProductPage1">
      <div class="Product_SDK">
        <div class="Product_SDK_title">
          <p>SDK</p>
          <span></span>
        </div>
        <div class="Product_SDK_text">
          <p>{{$t("Products.SDK.sdkpone")}}</p>
          <p>{{$t("Products.SDK.sdkptwo")}}</p>
          <p>{{$t("Products.SDK.sdkpthree")}}</p>
          <p style="font-weight:600;">{{$t("Products.SDK.sdkpfour")}}</p>
        </div>
        <div class="Product_SDK_content">
          <div class="Product_SDK_list">
            <div class="Product_SDK_list_img">
              <img style="margin-top:48px;" v-lazy="qianZhaung" alt="">
            </div>
            <p>{{$t("Products.SDK.Factory")}}</p>
          </div>
          <div class="Product_SDK_list">
            <div class="Product_SDK_list_img">
              <img v-lazy="houZhaung" alt="">
            </div>
            <p>{{$t("Products.SDK.Dash")}}</p>
          </div>
          <div class="Product_SDK_list">
            <div class="Product_SDK_list_img">
              <img v-lazy="ziNeng" alt="">
            </div>
            <p>{{$t("Products.SDK.Intelligent")}}</p>
          </div>
          <div class="Product_SDK_list">
            <div class="Product_SDK_list_img">
              <img v-lazy="daoHng" alt="">
            </div>
            <p>{{$t("Products.SDK.Navigation")}}</p>
          </div>
        </div>
      </div>

    </div>
    <!-- 服务平台 -->
    <div class="Product_wrapa" ref="ProductPage3">
      <div class="inner" ref="ProductPage4">
        <div class="Product_server">
          <div class="Product_server_title">
           
            <p>{{$t("Products.service.servicetitle")}}</p>
            <span></span>
          </div>
          <div class="Product_server_content">
            {{$t("Products.service.servicetext")}}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import headerbar from "../components/common/header.vue"
export default {
  name: 'Home',
  data() {
    return {
      clientHeight: '',
      parentMeg: "Products.commercial.Active",
      // serverMeg: "Products.service.servicetitle",
      parentMega: "Products.front.fronttitle",
      parentMegb: "SDK",
      qianZhaung: require("../assets/images/qianADAS.png"),
      houZhaung: require("../assets/images/houADAS.png"),
      ziNeng: require("../assets/images/znADAS.png"),
      daoHng: require("../assets/images/dHadas.png"),
      equipment1: require("../assets/images/qianshe.jpg"),
      equipment2: require("../assets/images/shebeib.png"),
      equipment3: require("../assets/images/fu.png"),
    }
  },
  components: { headerbar },

  mounted() {
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`          //document.body.clientWidth;
    //console.log(self.clientHeight);
    window.onresize = function temp() {
      this.clientHeight = `${document.documentElement.clientHeight}`;
    };
  },
  watch: {
    // 如果 `clientHeight` 发生改变，这个函数就会运行
    clientHeight: function() {
      this.changeFixed(this.clientHeight)
    }
  },
  methods: {
    changeFixed(clientHeight) {                        //动态修改样式
      console.log(clientHeight);
      this.$refs.ProductPage.style.height = clientHeight - 80 + 'px';
      if (document.documentElement.clientWidth >= 1270) {
        this.$refs.ProductPage1.style.height = clientHeight - 80 + 'px';
        this.$refs.ProductPage2.style.height = clientHeight - 80 + 'px';
        this.$refs.ProductPage3.style.height = clientHeight - 280 + 'px';
        this.$refs.ProductPage4.style.height = clientHeight - 280 + 'px';
      }
      //  this.$refs.ProductPage5.style.lienHeight = clientHeight - 80 + 'px';
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*.Product_wrap {
  width: 100%;
  
  background: url("../assets/images/shutterstock_589267616.png") no-repeat;
  background-size: 100% 100%;
}*/

@media screen and (max-width:1921px) {
  /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
  .Product_wrap {
    width: 100%;
    height: 100%;
    background: url("../assets/images/shutterstock_589267616.png") no-repeat center center;
    /*background-size: 100% 100%;*/
  }
}

@media screen and (min-width:1921px) {

  .Product_wrap {
    width: 100%;
    height: 100%;
    background: url("../assets/images/shutterstock_589267616.png") no-repeat center center;
    /*background-size: 100% 100%;*/
    background-color: #000;
  }
}






/*第一屏*/

.Product_content {
  width: 78%;
  margin: 0 auto;
}

.Product_content_title {
  width: 830px;
  height: 155px;
  font-size: 52px;
  /* font-family: PingFangSC-Semibold; */
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 77px;
  letter-spacing: 1px;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 5px;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}






/*第二屏*/

.TProduct_SDK {
  width: 78%;
  margin: 0px auto;
  text-align: center;
}

@media screen and (max-width:1510px) {
  /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
  .Product_SDK_title {
    padding-top: 50px;
    text-align: center;
  }
  .Product_SDK_content {
    display: flex;
    width: 850px;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 50px;
  }
  
  .Product_KY101_content {
    display: flex;
    width: 800px;
    margin: 0 auto;
    margin-top: 45px;
    position: relative;
  }
  .Product_KY-LFD_content {
    display: flex;
    /*width: 800px;*/
    margin: 0 auto;
    margin-top: 45px;
    position: relative;
  }
  .Product_vice_content {
    display: flex;
    /*clear: both;*/
    /*width: 800px;*/
    margin: 0 auto;
    margin-top: 110px;
    padding-bottom: 100px;
    position: relative;
  }
  .Product_server_title {
    padding-top: 60px;
    text-align: center;
  }
  .Product_server_content {
    width: 816px;
    /*height:90px;*/
    margin: 0 auto;
    text-align: center;
    font-size: 14px;
    /* font-family: PingFangSC-Regular; */
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 30px;
    margin-top: 70px;
    padding-bottom: 70px;
  }

  .Product_KY101_content_img {
    width: 500px;
    height: 377px;

    /*background: pink;*/
  }
  .Product_vice_pointTo {
    /*width: 365px;*/
    display: flex;
    height: 30px;
    line-height: 30px;
    text-align: center;
    position: absolute;
    bottom: 130px;
    left: 0px;
  }
}

@media screen and (min-width:1510px) and (max-width:1629px) {
  .Product_SDK_title {
    padding-top: 150px;
    text-align: center;
  }
  .Product_SDK_content {
    display: flex;
    width: 850px;
    margin: 0 auto;
    margin-top: 98px;
  }
 
  .Product_KY101_content {
    display: flex;
    width: 950px;
    margin: 0 auto;
    margin-top: 90px;
    position: relative;
  }
  .Product_KY-LFD_content {
    display: flex;
    width: 950px;
    margin: 0 auto;
    margin-top: 90px;
    position: relative;
  }
  .Product_vice_content {
    display: flex;
    /*clear: both;*/
    width: 800px;
    margin: 0 auto;
    margin-top: 260px;
    padding-bottom: 210px;
    position: relative;
  }
  .Product_server_title {
    padding-top: 180px;
    text-align: center;
  }
  .Product_server_content {
    width: 816px;
    /*height:90px;*/
    margin: 0 auto;
    text-align: center;
    font-size: 14px;
    /* font-family: PingFangSC-Regular; */
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 30px;
    margin-top: 120px;
  }

  .Product_KY101_content_img {
    width: 520px;
    height: 377px;

    /*background: pink;*/
  }
  .Product_vice_pointTo {
    /*width: 365px;*/
    display: flex;
    height: 30px;
    line-height: 30px;
    text-align: center;
    position: absolute;
    bottom: 240px;
    left: 0px;
  }
}

@media screen and (min-width:1630px) {
  .Product_SDK_title {
    padding-top: 170px;
    text-align: center;
  }
  .Product_SDK_content {
    display: flex;
    width: 850px;
    margin: 0 auto;
    margin-top: 98px;
  }
 
  .Product_KY101_content {
    display: flex;
    width: 950px;
    margin: 0 auto;
    margin-top: 90px;
    position: relative;
  }
  .Product_KY-LFD_content {
    display: flex;
    width: 950px;
    margin: 0 auto;
    margin-top: 90px;
    position: relative;
  }
  .Product_vice_content {
    display: flex;
    /*clear: both;*/
    width: 800px;
    margin: 0 auto;
    margin-top: 260px;
    padding-bottom: 210px;
    position: relative;
  }
  .Product_server_title {
    padding-top: 180px;
    text-align: center;
  }
  .Product_server_content {
    width: 816px;
    /*height:90px;*/
    margin: 0 auto;
    text-align: center;
    font-size: 14px;
    /* font-family: PingFangSC-Regular; */
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 30px;
    margin-top: 120px;
  }

  .Product_KY101_content_img {
    width: 520px;
    height: 377px;

    /*background: pink;*/
  }
  .Product_vice_pointTo {
    /*width: 365px;*/
    display: flex;
    height: 30px;
    line-height: 30px;
    text-align: center;
    position: absolute;
    bottom: 240px;
    left: 0px;
  }
}

.Product_SDK_title p {
  margin: 0px auto;
  width: 78px;
  height: 30px;
  font-size: 36px;
  /* font-family: PingFangSC-Semibold; */
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}

.Product_SDK_title span {
  display: inline-block;
  width: 40px;
  border-bottom: 3px solid red;
  margin-top: 23px;
}

.Product_SDK_text {
  margin-top: 60px;
}

.Product_SDK_text p {
  margin: 0px auto;
  width: 850px;
  height: 30px;
  font-size: 14px;
  /* font-family: PingFangSC-Regular; */
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  text-align: center;
}



.Product_SDK_list {
  margin-left: 17px;
  width: 192px;
  height: 222px;
  text-align: center;
  border: 1px solid #ccc;
}

.Product_SDK_list_img {
  width: 192px;
  height: 173px;
  border-bottom: 1px solid #ccc;
  background: #fff;
}

.Product_SDK_list_img img {
  /*display: inline-block;*/
  /* margin-top: 12px; */
  /*width:100%;*/
  height: 100%;
}

.Product_SDK_list p {
  line-height: 47px;
}








/*第三屏*/

.Product_KY101 {
  width: 78%;
  margin: 0px auto;
  /*text-align: center;*/
  /*position: relative;*/
}



.Product_KY101_title p {
  margin: 0px auto;
  width: 148px;
  height: 30px;
  font-size: 36px;
  /* font-family: PingFangSC-Semibold; */
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}

.Product_KY101_title span {
  display: inline-block;
  width: 40px;
  border-bottom: 3px solid red;
  margin-top: 23px;
}




.Product_KY101_content_img img {
  /*width:100%;*/
  height: 100%;
}

.Product_KY101_content_text {
  width: 380px;
  height: 120px;
  /*margin-left: 20px;*/
  margin-top: 45px;
}

.Product_KY101_content_text h3 {
  /*width:250px;*/
  height: 30px;
  font-size: 18px;
  /* font-family: PingFangSC-Medium; */
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  text-align: left;
}

.Product_KY101_content_text p {
  width: 360px;
  height: 90px;
  font-size: 14px;
  /* font-family: PingFangSC-Medium; */
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  text-align: left;
  margin-top: 15px;
}

.Product_KY101_pointTo {
  display: flex;
  /*width: 365px;*/
  height: 30px;
  line-height: 30px;
  text-align: center;
  position: absolute;
  bottom: 97px;
  left: 320px;
}

.Product_KY101_pointTo span {
  display: block;
}

.Product_KY101_pointTo span:first-child {
  width: 200px;
  height: 2px;
  margin: auto;
  background: #ff7989;
}

.Product_KY101_pointTo span:nth-child(2) {
  width: 8px;
  height: 8px;
  margin: auto;
  background: #ff7989;
  border-radius: 50%;
  line-height: 30px;
}

.Product_KY101_pointTo h5 {
  margin-left: 21px;
  display: block;
  min-width: 58px;
  height: 30px;
  font-size: 14px;
  /* font-family: PingFangSC-Medium; */
  /*font-weight:500;*/
  color: rgba(37, 38, 49, 1);
  line-height: 30px
}






/*第四屏*/

.Product_KY-LFD {
  width: 78%;
  margin: 0 auto;
}



.Product_KY-LFD_content_img {
  margin-left: 88px;
  width: 445px;
  height: 377px;
}

.Product_KY-LFD_content_img img {
  height: 100%;
}

.Product_KY-LFD_content_text {
  width: 398px;
  height: 120px;
  margin-top: 45px;
}

.Product_KY-LFD_content_text h3 {
  /*width:250px;*/
  height: 30px;
  font-size: 18px;
  /* font-family: PingFangSC-Medium; */
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  text-align: left;
}

.Product_KY-LFD_content_text p {
  width: 396px;
  /*height: 90px;*/
  font-size: 14px;
  /* font-family: PingFangSC-Medium; */
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  text-align: left;
  margin-top: 15px;
}

.Product_KY-LFD_pointTo {
  /*width: 365px;*/
  display: flex;
  height: 30px;
  line-height: 30px;
  text-align: center;
  position: absolute;
  bottom: 72px;
  left: 400px;
}

.Product_KY-LFD_pointTo span {
  display: block;
}

.Product_KY-LFD_pointTo span:first-child {
  width: 108px;
  height: 2px;
  margin: auto;
  background: #ff7989;
}

.Product_KY-LFD_pointTo span:nth-child(2) {
  width: 8px;
  height: 8px;
  background: #ff7989;
  border-radius: 50%;
  margin: auto;
}

.Product_KY-LFD_pointTo h5 {
  margin-left: 21px;
  display: inline-block;
  /*width: 58px;*/
  height: 30px;
  font-size: 14px;
  /* font-family: PingFangSC-Medium; */
  /*font-weight:500;*/
  color: rgba(37, 38, 49, 1);
  line-height: 30px
}



.Product_vice_content_img {
  width: 311px;
  height: 345px;
  margin-left: 50px;
}

.Product_vice_content_img img {
  height: 100%;
}

.Product_vice_content_text {
  width: 420px;
  height: 120px;
  margin-top: 33px;
}

.Product_vice_content_text h3 {
  width: 250px;
  height: 30px;
  font-size: 18px;
  /* font-family: PingFangSC-Medium; */
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  text-align: left;
}

.Product_vice_content_text p {
  min-width: 358px;
  font-size: 14px;
  /* font-family: PingFangSC-Medium; */
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  text-align: left;
  margin-top: 15px;
}



.Product_vice_pointTo span {
  display: block;
}

.Product_vice_pointTo h5 {
  margin-right: 21px;
  display: inline-block;
  height: 30px;
  font-size: 14px;
  /* font-family: PingFangSC-Medium; */
  color: rgba(37, 38, 49, 1);
  line-height: 30px
}

.Product_vice_pointTo span:nth-child(3) {

  width: 8px;
  height: 8px;
  background: #ff7989;
  border-radius: 50%;
  margin: auto;
}

.Product_vice_pointTo span:nth-child(2) {
  width: 387px;
  height: 2px;
  margin: auto;
  background: #ff7989;
}






/*第五屏*/

.Product_wrapa {
  width: 100%;
  background: url("../assets/images/BitmapCopy4.png");
  background-size: 100% 100%;
}

.Product_server {
  width: 78%;
  margin: 0 auto;
}





.Product_server_title p {
  margin: 0px auto;
  letter-spacing: 1px;
  width: 450px;
  text-align: center;
  height: 30px;
  font-size: 36px;
  /* font-family: PingFangSC-Semibold; */
  font-weight: 600;
  color: #fff;
  line-height: 30px;
}

.Product_server_title span {
  display: inline-block;
  width: 40px;
  border-bottom: 3px solid red;
  margin-top: 23px;
}
</style>



// WEBPACK FOOTER //
// src/components/Product.vue